"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListSellWithoutPwdRequestRequest = void 0;
var ListSellWithoutPwdRequestRequest = /** @class */ (function () {
    function ListSellWithoutPwdRequestRequest() {
    }
    return ListSellWithoutPwdRequestRequest;
}());
exports.ListSellWithoutPwdRequestRequest = ListSellWithoutPwdRequestRequest;
;
//# sourceMappingURL=listSellWithoutPwdRequest.request.js.map